import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

export const SuggestionLoader = () => (
  <Card p={4}>
    <Box flexDirection="column" gridRowGap={3}>
      {/* Header with title and navigation skeleton */}
      <Box justifyContent="space-between">
        <Box display="flex" alignItems="center" gridColumnGap={3}>
          {/* AI Icon skeleton */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="lightGrey"
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
            }}
          />
          {/* Title skeleton */}
          <Skeleton height={24} width={120} />
        </Box>
      </Box>

      {/* Content skeleton */}
      <Box flexDirection="column" gridRowGap={2}>
        {/* Main content skeleton */}
        <Box
          p={4}
          bg="lightestGrey"
          style={{
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
          }}
        >
          <Skeleton height={32} width="100%" />
        </Box>

        <Skeleton height={16} width="100%" />
      </Box>

      {/* Actions skeleton */}
      <Box display="flex" gridColumnGap={2}>
        <Skeleton height={36} width={80} />
        <Skeleton height={36} width={80} />
        <Skeleton height={36} width={80} />
      </Box>
    </Box>
  </Card>
);
